import { render, staticRenderFns } from "./Page8.vue?vue&type=template&id=10239b82&scoped=true&"
import script from "./Page8.vue?vue&type=script&lang=js&"
export * from "./Page8.vue?vue&type=script&lang=js&"
import style0 from "./Page8.vue?vue&type=style&index=0&id=10239b82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10239b82",
  null
  
)

export default component.exports